var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-upload",
    {
      attrs: {
        action: _vm.uploadUrl + "?workOrderNumber=" + _vm.workOrderNumber,
        multiple: "",
        headers: _vm.headers,
        "file-list": _vm.fileList,
        limit: 1,
        "on-success": _vm.handleSuccess,
        "auto-upload": true,
      },
    },
    [
      _c("el-button", { attrs: { size: "small", type: "primary" } }, [
        _vm._v("导入Bom数据"),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }